import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { AddEditFundingSourceModalComponent } from './add-edit-funding-source-modal/add-edit-funding-source-modal.component';
import { BaseFundingSourcePageComponent } from './base-funding-source-page/base-funding-source-page.component';
import { FundingSourceAuditTrailTableComponent } from './funding-source-audit-trail-table/funding-source-audit-trail-table.component';
import { FundingSourceCalculatorComponent } from './funding-source-calculator/funding-source-calculator.component';
import { FundingSourceDetailFlyoutComponent } from './funding-source-detail-flyout/funding-source-detail-flyout.component';
import { FundingSourceDetailPageComponent } from './funding-source-detail-page/funding-source-detail-page.component';
import { FundingSourceWrapperComponent } from './funding-source-wrapper/funding-source-wrapper.component';
import { OpenCloseFSModalComponent } from './open-close-fs-modal/open-close-fs-modal.component';

@NgModule({
  imports: [
    ScrollingModule,
    GCCoreModule
  ],
  declarations: [
    FundingSourceWrapperComponent,
    BaseFundingSourcePageComponent,
    AddEditFundingSourceModalComponent,
    FundingSourceCalculatorComponent,
    OpenCloseFSModalComponent,
    FundingSourceAuditTrailTableComponent,
    FundingSourceDetailPageComponent,
    FundingSourceDetailFlyoutComponent
  ],
  exports: [
    FundingSourceCalculatorComponent
  ]
})
export class FundingSourceModule { }
